import {classNames, React} from '@api'
import {HTMLDivProps} from '@blueprintjs/core'
import * as css from './Panel.css'

export const Panel = ({side, className, ...props}: HTMLDivProps & {side?: 'left' | 'center' | 'right'}) => <div {...props} data-type='Panel' className={classNames(css.root, className)} data-variant={side} />



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/Panel/Panel.tsx